<template>
  <NuxtSnackbar :duration="6000" @dismissed="removeDetails" @removed="removeDetails">
    <template #message-content="{ message, title, text }">
      <div class="snackbar-content">
        <div class="snackbar-text">
          <strong v-text="title" />
          <p v-if="text">
            <span v-if="withDetails">
              {{ text }}
            </span>
            <span v-else v-text="`(${text.CaseId})`" />
          </p>
          <div v-if="checkIfArray(message.message)">
            <div v-for="(line, index) in message.message" :key="index" v-text="line" />
          </div>
          <p v-else>
            <span v-if="!message.link" v-text="message.message" />
            <span v-else>
              <component
                :is="part"
                v-for="(part, index) in transformMessage(message.message, message.link)"
                :key="index"
              />
            </span>
          </p>
        </div>
        <div v-if="text && !withDetails" class="snackbar-action" @click="showMoreDetails">
          <SvgIcon value="MoreVert" />
        </div>
      </div>
    </template>
  </NuxtSnackbar>
</template>

<script setup lang="ts">
import { SvgIcon } from '@lw-design-system/ui';
import { h } from 'vue';
import { NuxtLink } from '#components';

const withDetails = ref(false);

const showMoreDetails = () => {
  withDetails.value = true;
};

const removeDetails = () => {
  withDetails.value = false;
};

const checkIfArray = (message: string[] | string) => {
  return Array.isArray(message);
};

const handleReturnToLine = (message: string) => {
  const lines = message
    .split('\n')
    .flatMap((line, i, arr) =>
      i < arr.length - 1 ? [h('span', line), h('br')] : [h('span', line)]
    );
  return lines;
};

const transformMessage = (message: string, link: string) => {
  const match = message.match(/\b(\d{5,})\b/);
  if (!match) return handleReturnToLine(message);

  const id = match[1];
  const parts = message.split(id);

  return parts.flatMap((part, i) => {
    const lines = handleReturnToLine(part);

    if (i === 0) return lines;
    return [
      h(
        NuxtLink,
        {
          to: link,
          class: 'snackbar-link body-bold-small'
        },
        { default: () => id }
      ),
      ...lines
    ];
  });
};
</script>

<style scoped>
.snackbar-text {
  word-wrap: break-word;
  display: flex;
  flex-direction: column;
}

.snackbar-content {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.snackbar-action {
  width: 1.5rem;
  height: 1.5rem;
  cursor: pointer;
}

.snackbar-link {
  color: inherit;
  text-decoration: underline;
  cursor: pointer;
}
</style>
